import React, { useEffect,useState } from "react";
import "./EmploymentVerification.css";
import InfoIcon from "../../assets/img/info.svg";
import { useDispatch, useSelector } from "react-redux";

const EmploymentGap = (props) => {
  const storeData = useSelector((state) => state.fetchGap);
  const { fetchGapData, loading } = storeData;
  const [gapData, setGapData] = useState();
  const [totalGap, setTotalGap] = useState();

  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if (loading === false) {
        if(typeof fetchGapData?.data != "undefined" && fetchGapData.data != null){
          setTotalGap(fetchGapData?.data?.total_gap)
          setGapData(fetchGapData?.data?.gaps)
         }
      } 
    }
    
  }, [fetchGapData, loading]);

  
 
  const handleReasonChange = (e,data) => {
    props.handleReasonCallback(e.target.value,data)
    

  }
  return (
    <>
      <div className="col-lg-8 col-md-10 col-sm-12 pt-3">
        {gapData!=null && gapData.length > 0 && 
        <div className="alert alert-warning mt-3 text-dark" role="alert">
          <span>
            <img
              src={InfoIcon}
              alt="InfoIcon"
              style={{ paddingBottom: "2px", paddingRight: "9px" }}
            />
          </span>
          Found Employment Gap of{" "}
          <span className="font-weight-bolder">{totalGap}</span>
        </div>}

        {/* reason */}
        {gapData!=null && gapData.length > 0 && gapData?.map((data,index)=><div className="empGapReasonsBox">
          <div className="empGapReasonTitle">
            {index+1}. {data?.gap_range}
            {/* 1. No Employment record found between{" "} */}
            {/* <span className="font-weight-bolder">Jun 2020 till Feb 2022</span> */}
          </div>
          <div className="empGapReason w-100 pt-2">
            <form>
              <div className="form-group">
                <label
                  for="exampleFormControlTextarea1"
                  className="empGaplabelInput"
                >
                  <span className="font-weight-bolder">Reason<sup className="text-danger">{''}*</sup></span>
                </label>
                <textarea
                  className="form-control w-100"
                  placeholder="Enter reason of Gap in employment"
                  id="exampleFormControlTextarea1"
                  rows="5"
                  value={props?.reasons[index]}
                  onChange={(e) => {handleReasonChange(e,index)}}
                ></textarea>
              </div>
            </form>
          </div>
        </div>)}
        
      </div>
    </>
  );
};

export default EmploymentGap;
